// MapWrapper.jsx
import { Map, Marker } from '@vis.gl/react-maplibre';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const MapWrapper = ({ longitude, latitude, zoom = 14, height = 400 }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      height,
      width: '100%',
      borderRadius: 2,
      overflow: 'hidden',
      border: `1px solid ${theme.palette.divider}`,
      position: 'relative'
    }}>
      <Map
        initialViewState={{
          longitude,
          latitude,
          zoom
        }}
        style={{ width: '100%', height: '100%' }}
        mapStyle="https://tiles.openfreemap.org/styles/liberty"
      >
        <Marker longitude={longitude} latitude={latitude} color="red" />
      </Map>
    </Box>
  );
};

export default MapWrapper;